import { forwardRef, Children, isValidElement } from 'react';
import { getTypographyStyles } from './TypographyStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const InternalTypography = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    component,
    variant = 'body1',
    variantTablet,
    variantDesktop,
    bold,
    children,
    ...rest
  } = _ref;
  const props = {
    ...rest,
    css: getTypographyStyles(variant, variantTablet, variantDesktop, bold)
  };
  if (typeof children === 'string' || component !== undefined) {
    const Tag = component || 'span';
    return jsx(Tag, {
      ...props,
      ref: ref,
      children: children
    });
  }
  if (!children) {
    return null;
  } else if (Children.count(children) === 1 && /*#__PURE__*/isValidElement(children)) {
    const child = Children.only(children);
    return jsx(child.type, {
      ...child.props,
      ...props,
      ref: ref
    });
  } else {
    throw new Error('Typography component expects one children tree or a string');
  }
});
InternalTypography.displayName = 'Typography';
const Typography = InternalTypography;

export { Typography };
//# sourceMappingURL=Typography.js.map
